import type { ISalesRecommendation } from "@voith-webshop/core-interfaces";
import type { SagaIterator } from "redux-saga";
import { call, fork, put, take } from "redux-saga/effects";
import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as salesRecommendationApi from "@/shop/api/personalized/salesRecommendation";

import * as SalesRecommendationActions from "./actions";

function* fetchSalesRecommendation(_: ActionType<typeof SalesRecommendationActions.fetchSalesRecommendation>): SagaIterator {
  try {
    yield put(SalesRecommendationActions.fetchSalesRecommendationStart());
    const data = (yield call(salesRecommendationApi.fetchSalesRecommendation)) as ISalesRecommendation[];
    yield put(SalesRecommendationActions.fetchSalesRecommendationSuccess(data));
  } catch (err) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    yield put(SalesRecommendationActions.fetchSalesRecommendationFail(err));
  }
}

function* fetchSalesRecommendationOnceSaga(): SagaIterator {
  const params = (yield take(getType(SalesRecommendationActions.fetchSalesRecommendation))) as ActionType<
    typeof SalesRecommendationActions.fetchSalesRecommendation
  >;
  yield fork(fetchSalesRecommendation, params);
}

export default function* salesRecommendationSaga(): SagaIterator {
  yield fork(fetchSalesRecommendationOnceSaga);
}
